"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flux = exports.mixin = exports.Component = exports.Provider = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.createRenderer = createRenderer;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _events = require("events");

var _promisedReducer = require("promised-reducer");

var _promisedReducer2 = _interopRequireDefault(_promisedReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // context


var SharedTypes = {
  emitter: _react2.default.PropTypes.any,
  rootProps: _react2.default.PropTypes.any
};

var Provider = exports.Provider = function (_React$Component) {
  _inherits(Provider, _React$Component);

  function Provider() {
    _classCallCheck(this, Provider);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Provider).apply(this, arguments));
  }

  _createClass(Provider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        emitter: this.props.emitter,
        rootProps: this.props
      };
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }], [{
    key: "childContextTypes",
    get: function get() {
      return SharedTypes;
    }
  }]);

  return Provider;
}(_react2.default.Component);

var Component = exports.Component = function (_React$Component2) {
  _inherits(Component, _React$Component2);

  function Component() {
    _classCallCheck(this, Component);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Component).apply(this, arguments));
  }

  _createClass(Component, [{
    key: "dispatch",
    value: function dispatch() {
      var _context$emitter;

      return (_context$emitter = this.context.emitter).emit.apply(_context$emitter, arguments);
    }
  }], [{
    key: "contextTypes",
    get: function get() {
      return SharedTypes;
    }
  }]);

  return Component;
}(_react2.default.Component);

var mixin = exports.mixin = {
  contextTypes: SharedTypes,
  dispatch: function dispatch() {
    var _context$emitter2;

    return (_context$emitter2 = this.context.emitter).emit.apply(_context$emitter2, arguments);
  }
};

function createRenderer(_ref) {
  var emitter = _ref.emitter;
  var render = _ref.render;

  return function (el) {
    return render(_react2.default.createElement(
      Provider,
      { emitter: emitter },
      el
    ));
  };
}

var Flux = exports.Flux = function (_PromisedReducer) {
  _inherits(Flux, _PromisedReducer);

  function Flux(_ref2) {
    var renderer = _ref2.renderer;
    var initialState = _ref2.initialState;
    var middlewares = _ref2.middlewares;

    _classCallCheck(this, Flux);

    var _this3 = _possibleConstructorReturn(this, Object.getPrototypeOf(Flux).call(this, initialState, middlewares));

    _this3._renderer = createRenderer({ emitter: _this3, render: renderer });
    _this3._renderedElement = null;

    _this3.on(":update", function () {
      _this3._renderedElement = _this3._renderer(_this3.render(_this3.state));
    });
    _this3.subscribe();
    return _this3;
  }

  _createClass(Flux, [{
    key: "_setState",
    value: function _setState() {
      if (this._renderedElement) {
        var _renderedElement;

        (_renderedElement = this._renderedElement).setState.apply(_renderedElement, arguments);
      }
    }
  }, {
    key: "subscribe",
    value: function subscribe() {
      // override me
    }
  }]);

  return Flux;
}(_promisedReducer2.default);